import { Link } from "react-router-dom";
import { Calendar } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/format";
import LeadStatusBadge from "@/components/LeadStatusBadge";

function relativeDay(iso) {
  if (!iso) return "—";
  const target = new Date(iso);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const t = new Date(target);
  t.setHours(0, 0, 0, 0);
  const diff = Math.round((t - today) / (1000 * 60 * 60 * 24));
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === -1) return "Yesterday";
  if (diff < 0) return `${Math.abs(diff)}d overdue`;
  return `In ${diff}d`;
}

function dueColor(iso) {
  if (!iso) return "#5C5C5C";
  const t = new Date(iso);
  t.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (t < today) return "#FF2A2A";
  if (t.getTime() === today.getTime()) return "#FF8C00";
  return "#00B341";
}

export default function FollowUpsWidget({ items = [] }) {
  return (
    <div className="bg-canvas-card border border-canvas-line">
      <div className="px-5 py-4 border-b border-canvas-line flex items-center justify-between">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink-muted mb-1">
            05 / Pipeline
          </div>
          <h3 className="font-display text-lg font-semibold text-ink">Upcoming follow-ups</h3>
        </div>
        <Calendar size={18} weight="bold" className="text-ink" />
      </div>
      <ul className="divide-y divide-canvas-line max-h-72 overflow-y-auto">
        {items.length === 0 && (
          <li className="px-5 py-8 font-mono text-xs text-ink-subtle text-center">
            No follow-ups scheduled.
          </li>
        )}
        {items.map((c) => (
          <li
            key={c.id}
            data-testid={`followup-${c.id}`}
            className="px-5 py-3 flex items-center justify-between gap-3"
          >
            <Link to={`/customers/${c.id}`} className="min-w-0 flex-1 group">
              <div className="text-sm font-semibold text-ink truncate group-hover:underline">
                {c.name}
              </div>
              <div className="font-mono text-[11px] text-ink-muted">
                {fmtDate(c.follow_up_date)}
              </div>
            </Link>
            <div className="flex items-center gap-2 shrink-0">
              <LeadStatusBadge status={c.status} />
              <span
                className="font-mono text-[11px] font-semibold"
                style={{ color: dueColor(c.follow_up_date) }}
              >
                {relativeDay(c.follow_up_date)}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
